import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import React from "react";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";

const DashboardUserSubtitle: React.FC = () => {
    const [user, status] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    if (status === "loading") {
        return <p>Loading...</p>;
    }

    if (status === "error") {
        return <p>Error loading your blender version.</p>;
    }

    if (user && user.blender_version) {
        return <p>Using Blender Version {user.blender_version}</p>;
    } else {
        return <p>Open Rend A Hand to Set Blender Version</p>;
    }
};

export default DashboardUserSubtitle;
